<template>
  <div class="margin-general">
    <div class="tradeview-evolution-content">
      <div class="tradeview-evolution-title">
        <h2>{{ $t("company.tradeview-evolution.title_") }}</h2>
      </div>
      <div ref="timelineContainer" class="timeline-container">
        <swiper
          :direction="'vertical'"
          :slidesPerView="'auto'"
          :spaceBetween="30"
          :navigation="true"
          :modules="modules"
          class="timeline"
          :reverseDirection="true"
          :centeredSlides="false"
          :breakpoints="{
            '640': {
              spaceBetween: 15,              
              centeredSlides: false
            }
          }"
        >
          <swiper-slide 
            class="timeline-item"
            v-for="item in events"
            :key="item.date"
            :class="item.side == 'left' ? 'timeline-item-right' : ''"
          >
              <div class="year">{{ $t(item.date) }}</div>
              <img src="/images/ellipse.svg" alt="" />
              <div class="body">
                <div class="vertical-line"></div>
                <div class="icon-box">
                  <span class="material-symbols-outlined icon" translate="no">{{
                    item.icon
                  }}</span>
                </div>
                <p class="title body-6-bold">{{ $t(item.title) }}</p>
                <p class="description body-4">{{ $t(item.description) }}</p>
              </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";

// import required modules
import { Pagination, Navigation } from "swiper/modules";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  computed: {
    isLastItemVisible() {
      return this.visibleCount >= this.events.length;
    },
  },
  data() {
    return {
      events: [
        {
          icon: "rocket_launch",
          title: "company.tradeview-evolution.title1",
          date: "company.tradeview-evolution.date1",
          description:
            "company.tradeview-evolution.description1",
          side: "right",
        },
        {
          icon: "rocket_launch",
          title: "company.tradeview-evolution.title1",
          date: "company.tradeview-evolution.date1",
          description:
            "company.tradeview-evolution.description1",
          side: "right",
        },
        {
          icon: "flag",
          title: "company.tradeview-evolution.title2",
          date: "company.tradeview-evolution.date2",
          description:
            "company.tradeview-evolution.description2",
          side: "left",
        },
        {
          icon: "pan_zoom",
          title: "company.tradeview-evolution.title3",
          date: "company.tradeview-evolution.date3",
          description:
            "company.tradeview-evolution.description3",
          side: "right",
        },
        {
          icon: "fingerprint",
          title: "company.tradeview-evolution.title4",
          date: "company.tradeview-evolution.date4",
          description:
            "company.tradeview-evolution.description4",
          side: "left",
        },
        {
          icon: "conversion_path",
          title: "company.tradeview-evolution.title5",
          date: "company.tradeview-evolution.date5",
          description:
            "company.tradeview-evolution.description5",
          side: "right",
        },
        {
          icon: "star",
          title: "company.tradeview-evolution.title6",
          date: "company.tradeview-evolution.date6",
          description:
            "company.tradeview-evolution.description6",
          side: "left",
        },

        {
          icon: "brand_awareness",
          title: "company.tradeview-evolution.title7",
          date: "company.tradeview-evolution.date7",
          description:
            "company.tradeview-evolution.description7",
          side: "right",
        },
        {
          icon: "location_on",
          title: "company.tradeview-evolution.title8",
          date: "company.tradeview-evolution.date8",
          description:
            "company.tradeview-evolution.description8",
          side: "left",
        },
        {
          icon: "trophy",
          title: "company.tradeview-evolution.title9",
          date: "company.tradeview-evolution.date9",
          description:
            "company.tradeview-evolution.description9",
          side: "right",
        },
        {
          icon: "new_releases",
          title: "company.tradeview-evolution.title11",
          date: "company.tradeview-evolution.date11",
          description:
            "company.tradeview-evolution.description11",
          side: "right",
        },
        {
          icon: "groups",
          title: "company.tradeview-evolution.title12",
          date: "company.tradeview-evolution.date12",
          description:
            "company.tradeview-evolution.description12",
          side: "left",
        },
        {
          icon: "groups",
          title: "company.tradeview-evolution.title12",
          date: "company.tradeview-evolution.date12",
          description:
            "company.tradeview-evolution.description12",
          side: "right",
        },
      ],
      visibleCount: 3,
      modules: [Pagination, Navigation],
    };
  },
  created() {
    this.events.forEach((event, index) => {
      // event.side = index % 2 === 0 ? "right" : "left";
    });
  },
  methods: {

  },
  mounted() {

  },
  beforeDestroy() {

  },
};
</script>
